// this must be defined statically because at app start we don't have values from launchdarkly yet.

export const DD_RUM_SESSION_SAMPLE_RATE = 100;

export const DD_RUM_SESSION_REPLAY_SAMPLE_RATE = 100;

export const DD_RUM_FEATURE_FLAG_VALUE_MAX_LENGTH = 500;

export const isDdRumEnabled = DD_RUM_SESSION_SAMPLE_RATE > 0;
